import React from "react";
import CoreTools from "../services/CoreTools";
import "./Modal.css";

let lastModalKey = 0;
const watchers = [];
const aModals = [];

const Child = props => <div className="modal-mask">
    <div className="card card-body modal-container">
        <div className="form-outline mb-1">
            <h3 className="text-primary">{props.title}</h3>
        </div>
        {props.children}
    </div>
</div>;

const Parent = props => {
    const [modals, setModals] = React.useState([]);
    React.useEffect(() => {
        const watch = {cb: modalSet => setModals([...modalSet])};
        watchers.push(watch);
        return () => CoreTools.remove(watchers, watch);
    }, [setModals]);
    return modals;
};

const Load = (modalElement, props, cb) => {
    const modal = <Child key={++lastModalKey} title={props && props.title}>{
        React.cloneElement(
            modalElement, 
            Object.assign(
                CoreTools.isObject(props) ? props : {},
                {
                    close: (...res) => {
                        if (typeof(cb) === "function") {cb(...res);}
                        removeModal();
                    }
                }
            )
        )    
    }</Child>;
    const removeModal = () => {
        CoreTools.remove(aModals, modal);
        watchers.forEach(w => w.cb(aModals));
    };
    aModals.push(modal);
    watchers.forEach(w => w.cb(aModals));
    return {
        close: removeModal
    };
};

const Modal = {
    Child: Child,
    Parent: Parent,
    Load: Load
};

export default Modal;